/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export const BrandCarousalImages = [
  {
    id: 'puma_brand',
    image_url: 'https://assets.clear.in/cleartax/images/1696505670_frame33.png',
  },
  {
    id: 'ikea_brand',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d7821048-0cb1-4166-ad99-4806622afe5b.png',
  },
  {
    id: 'retail_star',
    image_url: 'https://assets.clear.in/cleartax/images/1696505869_frame24.png',
  },
  {
    id: 'retail_cinema',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/01442846-eb45-466d-a5d2-7b816fc89d4e.png',
  },
  {
    id: 'reckit_fmcg',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/4654ec24-7150-4b0e-89fc-97cf01d8e8ab.png',
  },
  {
    id: 'marico_fmcg',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/fdf2d2a4-a239-4df7-8436-bb41580e96cb.png',
  },
  {
    id: 'colgate_fmcg',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/a6037767-7cfb-4ce5-a1f8-1de5b2d8e582.png',
  },
  {
    id: 'bisleri_fmcg',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/4ed4c159-a751-4144-9047-c6f36c02bd14.png',
  },
  {
    id: 'cross_healthcare',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/63012f5a-8bcf-4d7a-8b57-61e9814e302f.png',
  },
  {
    id: 'round_health',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/c4a34a53-cd84-4e5c-a94d-c646910fca70.png',
  },
  {
    id: 'othercross_health',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/aa4d7143-d920-4e57-aeb7-575606e5b200.png',
  },
  {
    id: 'teva_health',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/98659769-6100-4560-a9ee-3e1e2610c1d7.png',
  },
  {
    id: 'brigade',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/52b65ac5-5c74-4c79-aa5c-f22ad2da6889.png',
  },
  {
    id: 'dlf',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/5915c329-0479-4115-a5ad-572a98b9fc17.png',
  },
  {
    id: 'taj',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/07a56c91-cac1-4a4e-82b8-7cb421a590d1.png',
  },
  {
    id: 'marriot',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/99aa36ff-2b36-4c90-8951-8134c37c1dac.png',
  },
  {
    id: 'swiggy',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/eaab9f29-9f19-4ea9-8a65-8b2ab5fa6d1c.png',
  },
  {
    id: 'myntra',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/7f046248-1527-49ad-8059-19f4f987f7fa.png',
  },
  {
    id: 'zomato',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/9c80763d-1ec6-4ef3-b62e-4a28905d6359.png',
  },
  {
    id: 'flipkart',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/e4c02041-7292-49ed-b702-6adbbb27cb33.png',
  },
  {
    id: 'appolo',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/ab4147b7-e83a-4233-8f01-35b9c7df168e.png',
  },
  {
    id: 'bosch',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/ec1e12d5-2642-42f8-ba30-b6255b49cc61.png',
  },
  {
    id: 'beml',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/f7de093b-d715-4753-b69c-942d07bf8254.png',
  },
  {
    id: 'jktires',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/ba08a4c7-88cb-494e-9a7a-8f6535ec8c7e.png',
  },
  {
    id: 'schar',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d7bed507-414b-49be-b04b-988814fb1568.png',
  },
  {
    id: 'aig',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/56886759-23e0-4640-aea5-c420298063b7.png',
  },
  {
    id: 'sbicard',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d7a1d2c5-c260-4fc2-abbf-48df00b9a65e.png',
  },
  {
    id: 'baroda',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/2d175c53-5401-42ae-9613-bfe0519236b8.png',
  },
  {
    id: 'ola',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/af785b1c-c8db-48fe-a42d-e215f1ce2f4b.png',
  },
  {
    id: 'byjus',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/962317ff-5d68-4113-b4e2-8237dd67c867.png',
  },
  {
    id: 'udaan',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/caf09c84-cc0e-48ae-a2a9-c7f4bbb3880e.png',
  },
  {
    id: 'meesho',
    image_url:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/df29cdd8-5728-41ec-92cc-e71258843e9d.png',
  },
];

export const SelectProduct = [
  {
    label: 'GST',
    id: 'ClearGst',
    selected: false,
  },
  {
    label: 'TDS',
    id: 'ClearTDS',
    selected: false,
  },
  {
    label: 'TaxCloud',
    id: 'ClearTaxCloud',
    selected: false,
  },
  {
    label: 'e-Invoicing',
    id: 'ClearE-Invoicing',
    selected: false,
  },
  {
    label: 'Need more help',
    id: 'Need more help',
    selected: false,
  },
];

export const BrandCarousalTitles = [
  'Trusted by - Retail Brands',
  'Trusted by - FMCG Brands',
  'Trusted by - Healthcare & pharma Brands',
  'Trusted by - Hospitality & real estate Brands',
  'Trusted by - e-commerce Brands',
  'Trusted by - Manufacturing Brands',
  'Trusted by - Financial services Brands',
  'Trusted by - Others Brands',
];

export const companyTurnoverOptions = [
  { value: 'Greater than 500Cr', label: 'Greater than 500Cr' },
  { value: '200Cr-500Cr', label: '200Cr-500Cr' },
  { value: '50Cr-200Cr', label: '50Cr-200Cr' },
  { value: '25Cr-50Cr', label: '25Cr-50Cr' },
  { value: 'Less than 25Cr', label: 'Less than 25Cr' },
];

export const radioButtonArray = [
  {
    id: 1,
    title: 'Tax & Compliance Solutions',
    subHeading:
      '(GST, IMS, Max ITC, e-Invoicing & e-Way bill, TDS, Invoicing, Notice Management)',
    productId: 'ClearTaxComplianceSolutions',
    selected: true,
  },
  {
    id: 2,
    title: 'Supply Chain & Accounts Payable Automation',
    subHeading: '(Vendor Onboarding, Accounts Payable, Invoice Discounting)',
    productId: 'ClearSC-AP',
    selected: false,
  },
  {
    id: 3,
    title: 'Secretarial Automation',
    subHeading: '(Cimplyfive)',
    productId: 'Secretarial Automation',
    selected: false,
  },
  {
    id: 4,
    title: 'Others',
    subHeading: '',
    productId: 'Others',
    selected: false,
  },
];

export const demoLanguageOptions = [
  { value: 'English', label: 'English' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'Bengali', label: 'Bengali' },
  { value: 'Tamil', label: 'Tamil' },
  { value: 'Telugu', label: 'Telugu' },
  { value: 'Kannada', label: 'Kannada' },
  { value: 'Malayalam', label: 'Malayalam' },
];

export const teamStrengthOptions = [
  { value: 'Only Me', label: 'Only Me' },
  { value: '1-5 persons', label: '1-5 persons' },
  { value: '6-10 persons', label: '6-10 persons' },
  { value: 'More than 10 persons', label: 'More than 10 persons' },
];

export const clientNumberOptions = [
  { value: '1-25', label: '1-25' },
  { value: '26-50', label: '26-50' },
  { value: '51-100', label: '51-100' },
  { value: 'More than 100', label: 'More than 100' },
];

export const designationOptions = [
  { value: 'Chief Financial Officer', label: 'Chief Financial Officer' },
  {
    value: 'Head/VP/Director/GM (Finance/ Taxation)',
    label: 'Head/VP/Director/GM (Finance/ Taxation)',
  },
  {
    value: 'Head/VP/Director/GM (Accounts/Audit)',
    label: 'Head/VP/Director/GM (Accounts/Audit)',
  },
  {
    value: 'Senior Manager (Finance/ Taxation)',
    label: 'Senior Manager (Finance/ Taxation)',
  },
  {
    value: 'Senior Manager (Accounts/ Audit)',
    label: 'Senior Manager (Accounts/ Audit)',
  },
  { value: 'Senior Manager - AP', label: 'Senior Manager - AP' },
  {
    value: 'Senior Manager - Direct Tax',
    label: 'Senior Manager - Direct Tax',
  },
  {
    value: 'Senior Manager - Head/Treasury',
    label: 'Senior Manager - Head/Treasury',
  },
  { value: 'Company Secretary', label: 'Company Secretary' },
  { value: 'Legal Counsel', label: 'Legal Counsel' },
  { value: 'Director', label: 'Director' },
  { value: 'Other', label: 'Other' },
];

export const BLACKLIST = [
  'updated.com',
  'cleartax.in',
  'id.in',
  'xyz.com',
  'nil.com',
  'xx.xx',
  'abc.com',
  'live.com',
  'mail.com',
  'gamil.com',
  'junk.com',
  'gmai.com',
  'abc.in',
  'live.in',
  'a.com',
  'x.x',
  'a.a',
  'leads.com',
  'in.ey.com',
  '123.com',
  'xx.x',
  'xxx.com',
  'aa.aa',
  'redfm.in',
  'zz.zz',
  'yhaoo.co.in',
  'yahoo.om',
  'yahoo.com.au',
  'yahoo.co',
  'yahoo.ca',
  'yaho.co.in',
  'xxx.xx',
  'x.xx',
  'x.com',
  'abad.in',
  '123gmail.com',
  'z.z',
  'yohoo.com',
  'ymail.co',
  'yahooco.in',
  'yahoo.on',
  'yahoo.con',
  'yahoo.comm',
  'yahoo.com.sg',
  'yahoo.com.in',
  'yahoo.coin',
  'yahoo.co.on',
  'yahoo.co.om',
  'yahoo.cim',
  'yahoo.aco.in',
  'yahho.com',
  'xzy.com',
  'xyz.in',
  'xyz.c',
  'xys.com',
  'xxxx.xxx',
  'xxx.xxx',
  'xx.in',
  'xx.com',
  '143gmail.com',
  '126.com',
  '123.comk',
  'ac.com',
  'gmail.co',
  'gmail.con',
  'gmail.in',
  'gmailasdc.comm',
  'gmail.nba',
  'gmail.co.za',
  'gmail.co.in',
  'gmai.vom',
  'gmail.demo',
  'gmali.com',
  'gml.com',
  'gma.com',
  'gm.com',
  'gmail.org',
  'gmile.com',
  'gmai.com',
  'gmil.com',
  'gmal.com',
  'gmaiol.com',
  'gmnail.com',
  'gmailsdc.com',
  'gmeil.com',
  'gmail.comme',
  'gmail.com.my',
  'gmail.come',
  'gmail.comm',
  '111111gmail.com',
  'gmail.commau',
  'gmail.comgmail.com',
  'gmail.como',
  'gmail.comtt',
  'gmail.coma',
  'gamil.co',
  'gamil.com',
  'yahoo.com',
  'YAHOO.IN',
  'yahoo.co.in',
  'email.com',
  'email.in',
  'REDIFFMAIL.COM',
  'gmail.org',
];
export enum requestParamEnum {
  NAME = 'name',
  PHONE_NUMBER = 'phone_number',
  EMAIL = 'email',
  PREFERRED_LANGUAGE = 'preferred_language',
  TURNOVER = 'turnover',
  DESIGNATION = 'designation',
  TEAM_MEMBERS = 'team_members',
  NO_OF_CLIENTS = 'no_of_clients',
  PRODUCT_SELECTED = 'product_selected',
  WHATSAPP_CONSENT = 'whatsapp_consent',
  COMPANY_NAME = 'company_name',
  INTERESTED_PRODUCT = 'product_selected',
}

export const verificationTurnover = ['Less than 25Cr', '25Cr-50Cr'];
